module.exports = __webpack_public_path__ + "static/media/foto_p.b1a68204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/foto_p.jpg
// module id = 1297
// module chunks = 0